import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import {Provider}  from 'react-redux';
import store, {history, persistor} from "./store/store";
import {PersistGate} from "redux-persist/es/integration/react";
import {DragDropContextProvider} from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";

ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <DragDropContextProvider  backend={HTML5Backend}>
                <App History={history}/>
            </DragDropContextProvider>
        </PersistGate>
    </Provider>
    , document.getElementById('root')
);
